var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ApiPropertyOptional } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { DocumentRetrievalLocationStatus, DocumentRetrievalTaskStatus, AddedByTrigger } from "./document.retrieval.dtos";
import { PreviewMetadata } from "./preview.dtos";
export var ScreenshotMetadataStatus;
(function (ScreenshotMetadataStatus) {
    ScreenshotMetadataStatus["JOB_QUEUED"] = "JOB_QUEUED";
    ScreenshotMetadataStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ScreenshotMetadataStatus["COMPLETED"] = "COMPLETED";
    ScreenshotMetadataStatus["ERROR"] = "ERROR";
})(ScreenshotMetadataStatus || (ScreenshotMetadataStatus = {}));
export var ScreenshotWaitStrategy;
(function (ScreenshotWaitStrategy) {
    ScreenshotWaitStrategy["WAIT_FOR_SELECTOR"] = "WAIT_FOR_SELECTOR";
    ScreenshotWaitStrategy["WAIT_FOR_HIDDEN"] = "WAIT_FOR_HIDDEN";
    ScreenshotWaitStrategy["WAIT_FOR_ALL_REMOVED"] = "WAIT_FOR_ALL_REMOVED";
})(ScreenshotWaitStrategy || (ScreenshotWaitStrategy = {}));
export const screenshotResourceLoadingClass = "screenshot-resource-loading";
export class ConsentFlowDocumentRetrievalDocument {
}
__decorate([
    IsEnum(DocumentRetrievalTaskStatus)
], ConsentFlowDocumentRetrievalDocument.prototype, "status", void 0);
export class ConsentFlowDocumentRetrievalLocation {
}
__decorate([
    IsString()
], ConsentFlowDocumentRetrievalLocation.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional()
], ConsentFlowDocumentRetrievalLocation.prototype, "logoUrl", void 0);
__decorate([
    Type(() => ConsentFlowDocumentRetrievalDocument),
    IsArray(),
    ValidateNested({ each: true })
], ConsentFlowDocumentRetrievalLocation.prototype, "documents", void 0);
__decorate([
    IsEnum(DocumentRetrievalLocationStatus)
], ConsentFlowDocumentRetrievalLocation.prototype, "status", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], ConsentFlowDocumentRetrievalLocation.prototype, "isExcluded", void 0);
__decorate([
    IsEnum(AddedByTrigger),
    IsOptional()
], ConsentFlowDocumentRetrievalLocation.prototype, "addedBy", void 0);
export class ScreenshotImage {
}
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional()
], ScreenshotImage.prototype, "imageUrl", void 0);
__decorate([
    ApiPropertyOptional(),
    IsNumber(),
    IsOptional()
], ScreenshotImage.prototype, "step", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional()
], ScreenshotImage.prototype, "name", void 0);
export class PreviewScreenshot extends PreviewMetadata {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(ScreenshotMetadataStatus)
], PreviewScreenshot.prototype, "status", void 0);
__decorate([
    IsString(),
    IsOptional()
], PreviewScreenshot.prototype, "pdfUrl", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional()
], PreviewScreenshot.prototype, "generatedAt", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], PreviewScreenshot.prototype, "canUpdate", void 0);
